import { checkDecimal } from '../../../utils/validatorWrapper'
import { appConfig, GAL_MODELS } from './constants'
import useStaticData from './useStaticData'

/*
/ace.html?adhesiveAnchor=SET-XP&drillBitDiameter=1.125&
          embedmentDepth=36.00&insertDiameter=1&insertType=Rebar&subApp=0
*/
export const validateParams = (source) => {
  let errors = []
  errors =  Object.entries(source).reduce((result, [key, val]) => {
    val.trim()
    let my = 0
    if ( typeof val === 'object' ) {
      result.push('invalid name ' + key )
    } else if (key === 'source') {
      if (val !== 'ec' || val !== 'EC') {
        result.push('invalid ' + key + ' value ' + val )
      }
    } else if (key === 'sourceDomain') {
      //
    } else if (key === 'adhesiveAnchor') {
      if (val !== 'SET-3G' && val !== 'SET-XP' && val !== 'AT-XP' && val !== 'ET-3G') {
        result.push('invalid ' + key + ' value ' + val )
      }
    } else if (key === 'insertType') {
      if (val !== 'Rebar') {
        result.push('invalid ' + key + ' value ' + val )
      }
    } else if (key === 'subApp') {
      if (val !== '0' && val !== '1') {
        result.push('invalid ' + key + ' value ' + val )
      }
    } else if (key === 'embedmentDepth') {
      my = parseFloat(val)
      if (!checkDecimal(val) || (val <= 0 || val > 132)) {
        result.push('invalid ' + key + ' value ' + val )
      }
      source[key] = parseFloat(val).toString().replace(/\b0+/g, '')
    } else if (key === 'insertDiameter') {
      my = parseFloat(val)
      if (!checkDecimal(val)) {
        result.push('invalid ' + key + ' value ' + val )
      }
      source[key] = parseFloat(val).toString().replace(/\b0+/g, '')
    } else if (key === 'drillBitDiameter') {
      my = parseFloat(val)
      if (!checkDecimal(val)) {
        result.push('invalid ' + key + ' value ' + val )
      }
      source[key] = parseFloat(val).toString().replace(/\b0+/g, '')
    } else {
      result.push('invalid name ' + key )
    }

    return result

  }, [])

  return errors
}

export const getDowelingDefaultState = (initialState, staticData) => {
  const { adhesiveAnchor, insertType, insertDiameter } = initialState

  const list = staticData.applicationModels
  const adhesiveAnchorModel = list.find(item => item.product === initialState.adhesiveAnchor && item.default === true).model

  const { getDrillBitDiameterOptions, getScreenTubeOptions, showWaterFilledHolesInput } = useStaticData(staticData)
  const opts = getDrillBitDiameterOptions(adhesiveAnchor, insertType, insertDiameter)
  const screenTubeOptions = insertType.includes('Screen Tube') ? getScreenTubeOptions(adhesiveAnchor, insertType, insertDiameter): null
  const myDepth = insertType.includes('Screen Tube') ? {screenTube: screenTubeOptions[0].value, embedmentDepth: undefined } : { embedmentDepth: 6, screenTube: undefined }
  const showWaterFilledHoles = showWaterFilledHolesInput(insertType, adhesiveAnchor)
  const myWaterFilledHoles = showWaterFilledHoles ? { waterFilledHoles: false } : { waterFilledHoles: undefined }

  return Object.assign({}, initialState, {
    adhesiveAnchorModel: adhesiveAnchorModel,
    drillBitDiameter: opts[0].value,
  }, myDepth, myWaterFilledHoles)
}

export const getCIDefaultState = (initialState, staticData) => {
  const list = staticData.crackInjectionApplicationModels
  const injectionResinModel = list.find(item => item.product === initialState.injectionResin && item.default === true).model
  const pasteOverEpoxyModel = list.find(item => item.product === initialState.pasteOverEpoxy && item.default === true).model
  const pumpingPortModel = list.find(item => item.product === initialState.pumpingPortStyle && item.default === true).model
  const injectionFittingModel = list.find(item => item.product === 'Injection Fittings' && item.default === true).model

  const defaultCrackWidth = (initialState.injectionResin === 'CI-GV' || initialState.injectionResin === 'Crack-Pac Flex-H2O') ?
        { crackWidth: ".125" } : null

  return Object.assign({}, initialState, {
    injectionResinModel: injectionResinModel,
    pasteOverEpoxyModel: pasteOverEpoxyModel,
    pumpingPortModel: pumpingPortModel,
    injectionFittingModel: injectionFittingModel
  }, defaultCrackWidth)
}

const determineSubApp = (target, data) => {
  if (data.applicationModels.find(item => item.product === target)) {
    return '0'
  } else if (data.crackInjectionApplicationModels.find(item => item.product === target)) {
    return '1'
  } else {
    return '2'
  }
}

export const initCalculationCall = (params, data) => {
  // if (params.source === 'EC' && (params.injectionResin || params.pasteOverEpoxy)) {
  //
  //   let myInitial = Object.assign({}, data.crackInjectionInitialState, params)
  //   myInitial = getCIDefaultState(myInitial, data)
  //   return [ myInitial ]
  //
  // } else if (params.source === 'EC' && params.adhesiveAnchor) { // EC integration for adhesive
  //
  //   let myInitial = Object.assign({}, data.dowelingInitialState, params)
  //   myInitial = getDowelingDefaultState(myInitial, data)
  //   return [ myInitial ]
  // }

  if (params.source === 'EC' && params.sourceDomain && params.product && Object.keys(params).length === 3) { // EC integration
    const { source, sourceDomain, product } = params

    let myInitial = null
    let editedProduct = product
    let defaultData = null
    if (product === 'E-Z-Click Injection System') {
      defaultData = { injectionResin: 'CI-LV' }
      editedProduct = 'CI-LV'
    } else if (product === 'Opti-Mesh Adhesive-Anchoring Screen Tubes') {
      defaultData = { adhesiveAnchor: 'SET-XP', insertType: 'Plastic Screen Tube' }
      editedProduct = 'SET-XP'
    } else if (product === 'Steel Adhesive-Anchoring Screen Tubes') {
      defaultData = { adhesiveAnchor: 'ET-3G', insertType: 'Steel Screen Tube' }
      editedProduct = 'ET-3G'
    }

    const subApp = determineSubApp(editedProduct, data)
    if (subApp === '0' && !defaultData) {
      defaultData = { adhesiveAnchor: editedProduct }
    } else if (subApp === '2') {
      defaultData = { adhesiveAnchor: 'SET-3G' }   // invalid product from URL parameters is overrided with 'SET-3G'
    } else if (subApp === '1' && !defaultData) {
      defaultData = { injectionResin: editedProduct }
    }

    if (subApp === '0' || subApp === '2') {
      myInitial = Object.assign({}, data.dowelingInitialState, { source, sourceDomain }, defaultData)
      myInitial = getDowelingDefaultState(myInitial, data)
    } else {
      const isPasteOverEpoxy = data.crackInjectionOptions['pasteOverEpoxy'].find(item => item.value === editedProduct)
      myInitial = Object.assign({}, data.crackInjectionInitialState, { source, sourceDomain },
        isPasteOverEpoxy ? { pasteOverEpoxy: editedProduct } : defaultData)
      myInitial = getCIDefaultState(myInitial, data)
    }

    return [ myInitial ]

  } else if (params.source === 'EC' && params.sourceDomain && Object.keys(params).length === 2) { // EC integration

    let myInitial = Object.assign({}, data.dowelingInitialState, params)
    myInitial = getDowelingDefaultState(myInitial, data)
    return [ myInitial ]

  } else if (params.insertType === 'Rebar') {  // RDLC request

    const errors = validateParams(params)
    const myInitial = Object.assign({}, data.dowelingInitialState, params)
    return [ myInitial, errors ]

  } else {

    const myInitial = Object.assign({}, data.dowelingInitialState)
    return [ myInitial ]
  }
}

export const saveSettingState = (initialSetting) => {
  const itemName = 'sst_bp_' + appConfig.appCode + '_settings'
  const settingsJson = localStorage.getItem(itemName)
  let savedSetting = JSON.parse(settingsJson)
  if (savedSetting) {
    delete savedSetting.theme
  }

  const newSavedSetting = Object.assign({},
    {orientation: initialSetting.orientation, fontSize: initialSetting.fontSize}, savedSetting)
  localStorage.setItem(itemName, JSON.stringify(newSavedSetting))
}

export const convertOzToGal = (value) => value / 128

export const isGalModel = (applicationModel) =>
  Object.values(GAL_MODELS).includes(applicationModel.model)

export const getGalModelName = (applicationModel) => {
  const { model, cartridgeVolume } = applicationModel
  const galVolumne = convertOzToGal(cartridgeVolume)

  if (model === GAL_MODELS.ET3G2KT) return `${model} ${galVolumne} gal (pail)`
  if (model === GAL_MODELS.ET3G10KT) return `${model} ${galVolumne} gal (pail)`
  if (model === GAL_MODELS.ET3G100KT) return `${model} ${galVolumne} gal (drum)`
}

export const getApplicationModelName = (applicationModel) => {
  return isGalModel(applicationModel)
    ? getGalModelName(applicationModel)
    : `${applicationModel.model} ${applicationModel.cartridgeVolume} oz (cartridge)`
}
